<template>
   <div>
     <transition name="slide-fade">
        <div class="row" v-if="!showCustomLogin">
          <div class="col-sm-6">
            <div class="jumbotron">
              <h2>Sou Servidor do IFPE</h2>
              <p class="text-muted">Para todos os servidores do IFPE com acesso unificado</p>
              <p><a class="btn btn-success btn-lg" @click="askAuthIFPE" role="button">Entrar com minha conta</a></p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="jumbotron">
              <h2>Demais Usuários</h2>
              <p class="text-muted">Para todos os estudantes e usuários externos</p>
              <p><a class="btn btn-primary btn-lg" role="button" @click="showCustomLogin = true">Entrar/Cadastrar</a></p>
            </div>
          </div>
        </div>
     </transition>
     <transition name="slide-fade">
      <div class="row" v-if="showCustomLogin">
        <div class="form-signin">
          <h2 class="form-signin-heading">Acesso ao Sistema</h2>
          <transition name="fade">
            <div class="alert alert-warning" v-if="errorMessage">{{ errorMessage }}</div>
          </transition>
          <label for="inputLogin" class="sr-only">Email</label>
          <input type="email" id="inputLogin" v-model="login" @keyup.enter="doLogin" class="form-control" placeholder="Email" required autofocus>
          <label for="inputPassword" class="sr-only">Senha</label>
          <input type="password" id="inputPassword" v-model="password" @keyup.enter="doLogin" class="form-control" placeholder="Senha" required>
          <div class="row">
            <div class="col-sm-12">
              <button id="bntLogin" class="btn btn-lg btn-block btn-primary col-sm-6" @click="doLogin">Entrar</button>
            </div>
          </div>
          <transition name="fade">
            <div v-if="loading">
              <loader></loader>
            </div>
          </transition>
          <div class="extraActions">
            <p>
              <router-link to="/signup" >Não possui conta? Cadastre-se</router-link>
            </p>
            <p>
              <router-link to="/password-reset">Esqueci a senha</router-link>
            </p>
            <p>
              <a href="javascript:void()" @click="showCustomLogin = false">Voltar</a>
            </p>
          </div>
        </div>
      </div>
     </transition>
  </div>
</template>

<script>

  import {
    Parse,
    GlobalChannel,
    ifpeAuth
  } from '../Global'

  import Loader from './util/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        login: null,
        password: null,
        loading: false,
        errorMessage: null,
        showCustomLogin: false
      }
    },
    mounted () {
      this.errorMessage = 'Atenção: Este tipo de login não listará os editais voltados exclusivamente para os servidores do IFPE.'
      let accessToken = this.$route.params.access_token
      if (accessToken) {
        this.loginTokenIfpe(accessToken)
      }
    },
    methods: {
      doLogin () {
        let self = this
        if (!self.login || !self.password) {
          return
        }
        self.loading = true
        self.errorMessage = null
        Parse.User.logIn(self.login.toLowerCase(), self.password).then(user => {
          self.loading = false
          GlobalChannel.$emit('loginSuccess', self)
        }).fail(error => {
          self.loading = false
          self.errorMessage = error.message
        })
      },
      askAuthIFPE () {
        window.location.href = ifpeAuth.token.getUri() + '&nonce=' + Math.random().toString(36).substring(7)
      },
      loginTokenIfpe (accessToken) {
        let self = this
        self.loading = true
        Parse.Cloud.run('loginOauthIfpe', { accessToken }).then((token) => {
          return Parse.User.become(token)
        }).then(() => {
          self.loading = false
          GlobalChannel.$emit('loginSuccess', self)
        }).fail(error => {
          console.log(error)
          self.errorMessage = 'Erro ao autenticar'
        })
      }
    }
  }

</script>

<style scoped>
  .form-signin {
    max-width: 500px;
    padding: 15px;
    margin: 0 auto;
  }
  .form-signin .form-signin-heading {
    margin-bottom: 10px;
  }
  .form-signin .form-control {
    position: relative;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px;
    font-size: 15px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .extraActions {
    float: right;
    text-align: right;
    margin-top: 20px
  }
</style>



// WEBPACK FOOTER //
// Login.vue?69d109a2